export const changeLangtoEng = () => {
    return { type: "LANG_EN" };
};
export const changeLangtoFr = () => {
    return { type: "LANG_FR" };
};
